import i18n from 'i18next';
import { capitalize } from 'modules/core/utils';
import { IOption } from 'modules/core/types';
import { VehicleType } from 'modules/core/enums';

import { ADD_VEHICLE_FIELDS_NAMES } from './fieldNames.const';

export const INITIAL_DROPDOWN_VALUE = {
  title: undefined,
  value: undefined,
};

export const ADD_VEHICLE_FORM_INITIAL_VALUES = {
  vin: '',
  condition: INITIAL_DROPDOWN_VALUE,
  make: INITIAL_DROPDOWN_VALUE,
  model: INITIAL_DROPDOWN_VALUE,
  trim: '',
  year: INITIAL_DROPDOWN_VALUE,
  mileage: NaN,
  retailPrice: NaN,
  bookValue: NaN,
};

export const CREATE_USER_VEHICLE_INITIAL_VALUES = {
  id: NaN,
  odometer: NaN,
  book_value: NaN,
  current_price: NaN,
  loan_term: NaN,
  year: NaN,
};

export const CONDITION_OPTIONS: IOption[] = [
  {
    title: i18n.t('components.vehicleFilters.options.vehicleTypes.used'),
    value: capitalize(VehicleType.USED),
  },
  {
    title: i18n.t('components.vehicleFilters.options.vehicleTypes.new'),
    value: capitalize(VehicleType.NEW),
  },
];

export const AI_DECODABLE_FIELDS: string[] = [
  ADD_VEHICLE_FIELDS_NAMES.MAKE,
  ADD_VEHICLE_FIELDS_NAMES.MODEL,
  ADD_VEHICLE_FIELDS_NAMES.TRIM,
  ADD_VEHICLE_FIELDS_NAMES.YEAR,
  ADD_VEHICLE_FIELDS_NAMES.MILEAGE,
];

export const AI_DECODABLE_FIELDS_SPARKLES_INITIAL_VALUES = Object.fromEntries(
  AI_DECODABLE_FIELDS.map((key) => [key, false]),
);
